import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MIHttpClientService } from '../mi-http-client.service';
import { IMetricsWidget } from './widgets';


@Injectable({
  providedIn: 'root',
})
export class ReportsService {

  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  getMetricsWidget(): Observable<IMetricsWidget[]> {
    return this.miClient.get<IMetricsWidget[]>('reports/metricsWidget');
  }

  getDownLineMetricsWidget(userId: number): Observable<IMetricsWidget[]> {
    return this.miClient.get<IMetricsWidget[]>('reports/metricsWidget/' + userId);
  }

}
